module.exports = __webpack_public_path__ + "static/media/emoji-add-svgrepo-com.8851fe59.svg";